import { LocalStorage } from "./localStorage";

export const getToken = () => LocalStorage.getItem<string>("accessToken");
export const setToken = (token: string) => LocalStorage.setItem<string>("accessToken", token);
export const deleteToken = () => LocalStorage.deleteItem("accessToken");
